import axios from 'axios';

import { baseURL, isLocal } from './baseUrl';
import Domains from './domains';

import lcMsgTips from '@/utils/lcMsgTips';

const axiosInstance = axios.create({
  timeout: 10000, // 请求超时时间
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

axiosInstance.interceptors.request.use(
  (config) => {
    config.startTime = performance.now();
    if (config?.url?.endsWith('.json') && process.env.NEXT_PUBLIC_VERSION) {
      config.url = `${config.url}?version=${process.env.NEXT_PUBLIC_VERSION}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    if (response?.data?.code && response?.data?.code !== 200 && response?.data?.msg) {
      if (isLocal && response?.data?.code === 402) {
        return;
      }
      // 二进制数据则直接返回
      const responseType = response.request?.responseType;
      if (responseType === 'blob' || responseType === 'arraybuffer') {
        return response.data;
      }
      if (response?.data?.code === 411) {
        window.location.href = '/login.html';
      } else {
        if (!['needChooseCusType', 'needLogin'].includes(response?.data?.msg) && !response?.config?.noErrorModal) {
          lcMsgTips.showConfirmModal({
            title: response?.data?.msg || '系统繁忙，请联系客服人员或稍后再试！',
          });
        }
      }
    }
    return response.data;
  },
  (error) => {
    const endTime = performance.now();
    const reTime = endTime - error.config?.startTime;
    let reType = 'NetworkError';
    if (error.code === 'ECONNABORTED') {
      reType = 'TimeoutError';
    } else if (error.code >= 500 && error.code < 600) {
      reType = 'ServerError';
    }
    const errorDetails = {
      reType,
      reTime: reTime.toFixed(2),
      reMsg: error.message,
      reUrl: error.config?.url,
      reMethod: error.config?.method,
      reHeaders: JSON.stringify(error.config?.headers),
      reParams: JSON.stringify(error.config?.data),
      reCode: error.code,
    };
    console.error('接口异常：', errorDetails);
    return Promise.reject(error);
  }
);

const getBaseUrl = (domain) => {
  if (!domain) {
    return baseURL;
  }
  if (domain.startsWith('http://') || domain.startsWith('https://')) {
    return domain;
  }
  if (isLocal) {
    return `/${domain}`;
  }
  // 从会后缓存中获取域名信息
  return Domains[domain] || domain;
};

export function doPost(domain, url, data = {}, options) {
  if (Object.prototype.toString.call(data) === '[object FormData]') {
    options = {
      ...options,
      headers: {
        ...options?.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
  }
  return axiosInstance.post(url, data, {
    baseURL: getBaseUrl(domain),
    ...options,
  });
}

// GET请求
export function doGet(domain, url, params = {}, options = {}) {
  return axiosInstance.get(url, {
    params,
    baseURL: getBaseUrl(domain),
    ...options,
  });
}

export default function sendAxios({ baseURL, data, method, url, options, formData, headers, params }) {
  return axiosInstance({
    method,
    baseURL: getBaseUrl(baseURL),
    data,
    url,
    options,
    params,
    headers: {
      'Content-Type': formData ? 'application/x-www-form-urlencoded' : 'application/json',
      ...headers,
    },
  });
}
